import React from 'react';

import { OilSettings } from 'screens/shared';

const DieselEngineOil = (props) => {
  const engineValues = {
    normal: '200.0',
    reset: '400.0'
  };

  return <OilSettings engineValues={engineValues} {...props} />;
};

export default DieselEngineOil;



// WEBPACK FOOTER //
// ./src/screens/Diesel/DieselSettings/DieselEngineOil/DieselEngineOil.js